var exports = {
  "uW": "OperatorPassHoldingsSection.module__section___eFZ0U3",
  "Os": "OperatorPassHoldingsSection.module__group___eFZ0U3",
  "DD": "OperatorPassHoldingsSection.module__title___eFZ0U3",
  "dR": "OperatorPassHoldingsSection.module__dated___eFZ0U3",
  "p_": "OperatorPassHoldingsSection.module__list___eFZ0U3",
  "AS": "OperatorPassHoldingsSection.module__item___eFZ0U3",
  "rv": "OperatorPassHoldingsSection.module__itemText___eFZ0U3",
  "n8": "OperatorPassHoldingsSection.module__line___eFZ0U3",
  "mI": "OperatorPassHoldingsSection.module__meta___eFZ0U3",
  "uD": "OperatorPassHoldingsSection.module__textLink___eFZ0U3",
  "o1": "OperatorPassHoldingsSection.module__actions___eFZ0U3",
  "rd": "OperatorPassHoldingsSection.module__howLink___eFZ0U3",
};

module.exports = exports;
